import axios from "axios";

const api = axios.create({
  baseURL: "https://agecefce.descompliqueapps.com.br/wp/wp-json/",
});

export default api;
